import { CHART_COLLISION } from './chart-collision.js';
/** Architecture scales about the origin; furniture scales its anchor only. */
export function chartPartTransform(part, { width, height }) {
    const anchor = part.anchor ?? [0, 0, 0];
    return {
        position: [anchor[0] * width, anchor[1] * height, anchor[2] * width],
        scale: part.fixedScale ? [1, 1, 1] : [width, height, width],
    };
}
/** Shared by authoritative simulation, prediction and the offline scaler. */
export function createBlenderChartMap(asset, { width = 2, height = 1, playerCount = 8 } = {}) {
    if ([width, height].some(n => !Number.isFinite(n) || n <= 0))
        throw new RangeError('Scale must be positive and finite');
    if (!Number.isInteger(playerCount) || playerCount < 1 || playerCount > asset.spawns.length) {
        throw new RangeError(`Chart supports 1–${asset.spawns.length} players`);
    }
    return {
        id: 'spire', name: 'The Chart',
        platforms: asset.colliders.map((box, i) => {
            const t = chartPartTransform(box, { width, height }), a = box.anchor ?? [0, 0, 0];
            return { id: `chart-${i}`, partId: box.partId,
                x: (box.x - a[0]) * t.scale[0] + t.position[0],
                y: (box.y - a[1]) * t.scale[1] + t.position[1],
                z: (box.z - a[2]) * t.scale[2] + t.position[2],
                hx: box.hx * t.scale[0], hy: box.hy * t.scale[1], hz: box.hz * t.scale[2],
                solid: true, surface: box.surface ? { ...box.surface } : { kind: 'normal' } };
        }),
        spawns: asset.spawns.slice(0, playerCount).map(p => ({ x: p.x * width, y: p.y * height + 1, z: p.z * width })),
        floor: { kind: 'none' }, mutationFloorY: asset.mutationFloorY * height,
        visual: { builder: 'chart', asset: '/models/arenas/chart-v1.json', width, height },
        windZones: [], killY: -12, centerX: 0, centerZ: 0,
        startRadius: asset.radius * width, floorRadius: asset.radius * width, zoneCenterJitter: 0,
    };
}
export function createProductionChart(opts) {
    // world_init publishes the actual radius; it must reconstruct exactly once.
    const width = opts?.radius === undefined ? 2 : opts.radius / CHART_COLLISION.radius;
    return createBlenderChartMap(CHART_COLLISION, { width, playerCount: opts?.playerCount });
}
//# sourceMappingURL=chart.js.map